export default __webpack_public_path__ + "static/media/1.56f9fea8.jpg";